const config = {
    pubkon_backend_api: process.env.REACT_APP_PUBKON_BACKEND_API,
    conf_backend_api: process.env.REACT_APP_CONF_BACKEND_API,
    shopkon_api: process.env.REACT_APP_SHOPKON_API,
    static_file_url: process.env.REACT_APP_STATIC_FILE_URL,
}

export default config